<template>
  <section>
    <div class="z-card integration-page">
      <h2>{{ $t('integration.v2.142') }}</h2>
      <h3>{{ $t('integration.v2.143') }}</h3>

      <p>
        {{ $t('integration.v2.144') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/database-groups</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Params:</b> name</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>
        {{ $t('integration.api.answer_example') }}
      </p>

      <pre>
  <code class="json hljs">
  {

      <span class="hljs-attr">"id"</span>: <span class="hljs-number">85</span>,
      <span class="hljs-attr">"user_id"</span>: <span class="hljs-number">264</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"new test group85"</span>,
      <span class="hljs-attr">"database_count"</span>: <span class="hljs-number">0</span>,
      <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-10T13:25:37.000000Z"</span>,
      <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-10T13:26:31.000000Z"</span>,
      <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>
  }
  </code>
</pre>

      <h3>{{ $t('integration.v2.145') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Params:</b> database_group_id, sort_column, sort_direction</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>
        {{ $t('integration.v2.146') }}
      </p>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
  <code class="json hljs">
  {

      <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-number">83</span>,
      <span class="hljs-attr">"sort_column"</span>: <span class="hljs-string">"database_group_id"</span>,
      <span class="hljs-attr">"sort_direction"</span>: <span class="hljs-string">"asc"</span>
  }
  </code>
</pre>

      <p>
        {{ $t('integration.v2.147') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li><b>database_group_id</b> - {{ $t('integration.v2.148') }}</li>
        <li><b>sort_column</b> - {{ $t('integration.v2.149') }}</li>
        <li><b>sort_direction</b> - {{ $t('integration.v2.150') }}</li>
      </ul>

      <p>{{ $t('integration.api.answer_example') }}</p>

      <pre>
  <code class="json hljs">
  {

      <span class="hljs-attr">"meta"</span>: {
        <span class="hljs-attr">"total"</span>: <span class="hljs-number">5</span>,
        <span class="hljs-attr">"items_per_page"</span>: <span class="hljs-number">20</span>,
        <span class="hljs-attr">"current_page"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"total_pages"</span>: <span class="hljs-number">1</span>
      },
      <span class="hljs-attr">"data"</span>: [
      {
        <span class="hljs-attr">"id"</span>: <span class="hljs-string">19</span>,
        <span class="hljs-attr">"user_id"</span>: <span class="hljs-string">264</span>,
        <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-string">83</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"ready"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"{{ $t('integration.v2.152') }}"</span>,
        <span class="hljs-attr">"recipient_count"</span>: <span class="hljs-string">0</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-09T11:48:18.000000Z"</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-09T11:48:18.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-string">null</span>,
        <span class="hljs-attr">"recipients_count"</span>: <span class="hljs-string">0</span>,
        <span class="hljs-attr">"database_group"</span>: {
          <span class="hljs-attr">"id"</span>: <span class="hljs-number">83</span>,
          <span class="hljs-attr">"user_id"</span>: <span class="hljs-number">264</span>,
          <span class="hljs-attr">"name"</span>: <span class="hljs-string">"new"</span>,
          <span class="hljs-attr">"database_count"</span>: <span class="hljs-number">0</span>,
          <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-03-02T14:50:48.000000Z"</span>,
          <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-03-02T14:50:48.000000Z"</span>,
          <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>
        }
        <span class="hljs-attr">"sort_direction"</span>: <span class="hljs-string">"asc"</span> 

      },
      ...
      ]
      
  }
  </code>
</pre>

      <h2>{{ $t('integration.v2.151') }}</h2>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Params:</b> name</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"name"</span>: <span class="hljs-string">"{{ $t('integration.v2.152') }}"</span>,
    <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-number">83</span>
  }
  </code>
</pre>
      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"id"</span>: <span class="hljs-number">2139</span>,
    <span class="hljs-attr">"user_id"</span>: <span class="hljs-number">264</span>,
    <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-number">83</span>,
    <span class="hljs-attr">"state"</span>: <span class="hljs-string">"ready"</span>,
    <span class="hljs-attr">"name"</span>: <span class="hljs-string">"{{ $t('integration.v2.152') }}"</span>,
    <span class="hljs-attr">"recipient_count"</span>: <span class="hljs-number">0</span>,
    <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-11T16:16:55.000000Z"</span>,
    <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-11T16:16:55.000000Z"</span>,
    <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>
  }
  </code>
</pre>

      <h3>{{ $t('integration.v2.153') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases/{id}/recipients</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Params:</b> database_group_id, sort_column, sort_direction</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.v2.154') }}</p>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Params:</b> search</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <div class="api-doc-hint">
        <div class="flex">
          <div class="mr-2">&#128161;</div>
          <p>
            <span v-html="$t('integration.v2.155')"> </span> <u>items_per_page</u>
            {{ $t('integration.v2.156') }}
          </p>
        </div>
      </div>
      <p v-html="$t('integration.v2.157')"></p>
      <p>{{ $t('integration.api.answer_example') }}</p>

      <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"meta"</span>: {
      <span class="hljs-attr">"total"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"items_per_page"</span>: <span class="hljs-number">20</span>,
      <span class="hljs-attr">"current_page"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"total_pages"</span>: <span class="hljs-number">1</span>  
    }
    <span class="hljs-attr">"data"</span>: [
      {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"database_id"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79231500224"</span>,
        <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
        <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
        <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Alice"</span>,
        <span class="hljs-attr">"first_name"</span>: <span class="hljs-number">null</span>,
        <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
        <span class="hljs-attr">"age"</span>: <span class="hljs-number">22</span>,
        <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
        <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
        <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
        <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
        <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
        <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
        <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">"1"</span>,
        <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"vk.com?id=0123456789"</span>,
        <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>,
        <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">null</span>,
        <span class="hljs-attr">"fields"</span>: <span class="hljs-string">[]</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">null</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-09T14:49:04.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>,
      },
      ...
    ]
  }
  </code>
</pre>

      <h3>{{ $t('integration.v2.158') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases/{id}/recipients</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79009009090"</span>,
      <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
      <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Nick"</span>,
      <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
      <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
      <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
      <span class="hljs-attr">"age"</span>: <span class="hljs-string">"22"</span>,
      <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
      <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
      <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
      <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
      <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">""</span>,
      <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"1234"</span>,
      <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>
  }
  </code>
</pre>

      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">30637</span>,
      <span class="hljs-attr">"database_id"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79009009090"</span>,
      <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
      <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Nick"</span>,
      <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
      <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
      <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
      <span class="hljs-attr">"age"</span>: <span class="hljs-string">"22"</span>,
      <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
      <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
      <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
      <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
      <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">""</span>,
      <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"1234"</span>,
      <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>
      <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">null</span>
      <span class="hljs-attr">"fields"</span>: <span class="hljs-string">[]</span>
      <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>
      <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>
      <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-string">null</span>
  }
  </code>
</pre>

      <h3>{{ $t('integration.v2.159') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases/{id}/recipients/{recipient_id}</li>
        <p>
          {{ $t('integration.v2.160') }}
        </p>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> DELETE</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.api.answer_example') }} no content</p>

      <h3>{{ $t('integration.v2.161') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v3/databases/{id}/recipients/{recipient_id}</li>
        <p>
          {{ $t('integration.v2.162') }}
        </p>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> PUT</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.v2.163') }}</p>
      <p>{{ $t('integration.api.example') }}</p>

      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79231500000"</span>,
      <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
      <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Nick"</span>,
      <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
      <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
      <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
      <span class="hljs-attr">"age"</span>: <span class="hljs-string">"22"</span>,
      <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
      <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
      <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
      <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
      <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">"1"</span>,
      <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"1234"</span>,
      <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>
  }
  </code>
</pre>

      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">30637</span>,
      <span class="hljs-attr">"database_id"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79231500000"</span>,
      <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
      <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Nick"</span>,
      <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
      <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
      <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
      <span class="hljs-attr">"age"</span>: <span class="hljs-string">"22"</span>,
      <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
      <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
      <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
      <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
      <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">"1"</span>,
      <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"1234"</span>,
      <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>,
      <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">null</span>,
      <span class="hljs-attr">"fields"</span>: <span class="hljs-string">[]</span>,
      <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>,
      <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>,
      <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-string">null</span>,
      <span class="hljs-attr">"database"</span>: {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"user_id"</span>: <span class="hljs-number">264</span>,
        <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-number">null</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"error"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"{{ $t('integration.v2.152') }}"</span>,
        <span class="hljs-attr">"recipient_count"</span>: <span class="hljs-number">0</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-08T15:06:52.000000Z"</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-12T08:27:42.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>,
      }
  }
  </code>
</pre>
      <p>{{ $t('integration.v2.164') }}</p>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b>https://my.zorra.com/api/v3/databases/{id}/recipients/{recipient_id}</li>
        <p>
          {{ $t('integration.v2.165') }}
        </p>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">30637</span>,
      <span class="hljs-attr">"database_id"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79231500000"</span>,
      <span class="hljs-attr">"mcc"</span>: <span class="hljs-number">250</span>,
      <span class="hljs-attr">"mnc"</span>: <span class="hljs-number">2</span>,
      <span class="hljs-attr">"email"</span>: <span class="hljs-string">"email@example.com"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Nick"</span>,
      <span class="hljs-attr">"last_name"</span>: <span class="hljs-string">"Admin"</span>,
      <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
      <span class="hljs-attr">"country"</span>: <span class="hljs-string">"USA"</span>,
      <span class="hljs-attr">"age"</span>: <span class="hljs-string">"22"</span>,
      <span class="hljs-attr">"sex"</span>: <span class="hljs-string">"woman"</span>,
      <span class="hljs-attr">"birthdate"</span>: <span class="hljs-string">"2012-12-12 23:59:59"</span>,
      <span class="hljs-attr">"custom1"</span>: <span class="hljs-string">"{{ $t('integration.v2.166') }}"</span>,
      <span class="hljs-attr">"custom2"</span>: <span class="hljs-string">"vip_client"</span>,
      <span class="hljs-attr">"custom3"</span>: <span class="hljs-string">"1"</span>,
      <span class="hljs-attr">"custom4"</span>: <span class="hljs-string">"1234"</span>,
      <span class="hljs-attr">"custom5"</span>: <span class="hljs-string">"{{ $t('integration.v2.167') }}"</span>,
      <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">null</span>,
      <span class="hljs-attr">"fields"</span>: <span class="hljs-string">[]</span>,
      <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>,
      <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-12T08:32:54.000000Z"</span>,
      <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-string">null</span>,
      <span class="hljs-attr">"database"</span>: {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"user_id"</span>: <span class="hljs-number">264</span>,
        <span class="hljs-attr">"database_group_id"</span>: <span class="hljs-number">null</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"error"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"{{ $t('integration.v2.152') }}"</span>,
        <span class="hljs-attr">"recipient_count"</span>: <span class="hljs-number">0</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-08-08T15:06:52.000000Z"</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2022-08-12T08:27:42.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>,
      }
  }
  </code>
</pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
